module.exports = __webpack_public_path__ + "img/17_85.dae64f5a.png";